module.exports = __webpack_public_path__ + "loadingLogo.db677102.gif";